// extracted by mini-css-extract-plugin
module.exports = {"alert":"AlertError_alert__13yGB","message":"AlertError_message__HBweR","rotate":"AlertError_rotate__3DgD9"};